import { useCallback, useContext } from 'react';
import { useRecoilState } from 'recoil';
import * as sharedAtoms from '@ubeya/shared/atoms/shared';
import PrivilegesContext from '../contexts/PrivilegesContext';
import privileges from '../privileges';

const useChatIframe = () => {
  const [status, setStatus] = useRecoilState(sharedAtoms.isChatOpen);
  const myPrivileges = useContext(PrivilegesContext);
  const hasViewChatPrivilege = !!myPrivileges[privileges.VIEW_CHAT];

  const handleToggle = useCallback(
    (open, url = '') => {
      if (open && !hasViewChatPrivilege) {
        return;
      }

      setStatus({ isOpen: open, url });
    },
    [hasViewChatPrivilege, setStatus]
  );

  const openUserChat = useCallback((userId, accountId) => handleToggle(true, `invite/${userId}-user/${accountId}`), [
    handleToggle
  ]);

  return { handleToggle, openUserChat, hasViewChatPrivilege, ...status };
};

export default useChatIframe;
